import { TabsMenu, StyledButton, TabPanelsContainer } from './styles';

const items = [
  {
    label: 'Техническая информация',
    key: 0,
  },
  { label: 'Дополнительная информация', key: 1 },
  { label: 'Настройка карточки ЭЗС', key: 2 },
  { label: 'OCPP конфиг', key: 3 },
];

type Props = {
  activeKey: number;
  onClick: (step: number) => void;
  disabledTabs: number[];
};

export function ChargePointFormTabs({
  onClick,
  activeKey,
  disabledTabs,
}: Props) {
  return (
    <TabPanelsContainer>
      <TabsMenu>
        {items.map(({ key, label }) => (
          <StyledButton
            active={key === activeKey}
            key={key}
            onClick={() => onClick(key)}
            disabled={disabledTabs.includes(key)}
          >
            {label}
          </StyledButton>
        ))}
      </TabsMenu>
    </TabPanelsContainer>
  );
}
